export default "__VITE_ASSET__D_i0QWPs__"